// extracted by mini-css-extract-plugin
module.exports = {"button":"ToggleLimitOrder_button__1p76_","on":"ToggleLimitOrder_on__1fewr","toggle":"ToggleLimitOrder_toggle__p19in","load":"ToggleLimitOrder_load__169-s"};